export const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
export const SUGGESTION_LIMIT = 10

export const isPartner = source =>
    String(source || '').toLowerCase() === 'cqatspartner'

export const sourceLabel = source =>
    (isPartner(source) ? 'Cintas partner' : 'Recent')

export const topRecentSuggestions = (recipients, chips, limit = 5) => {
    const chosen = new Set(
        (chips || []).map(chip => String(chip.email || '').toLowerCase()),
    )
    return (recipients || [])
        .filter(item => {
            if (!item?.email || isPartner(item.source)) return false
            return !chosen.has(item.email.toLowerCase())
        })
        .slice(0, limit)
}

export const isValidEmail = value =>
    EMAIL_PATTERN.test(String(value || '').trim())

export const chipLabel = chip =>
    (chip?.name ? String(chip.name) : chip?.email || '')

const readName = item => {
    const direct =
        item?.Name ||
        item?.name ||
        item?.FullName ||
        item?.fullName ||
        item?.DisplayName ||
        item?.displayName ||
        ''
    const directName = String(direct || '').trim()
    if (directName && directName.toLowerCase() !== 'null') return directName
    const first = String(item?.FirstName || item?.firstName || '').trim()
    const last = String(item?.LastName || item?.lastName || '').trim()
    return `${first} ${last}`.trim()
}

export const normalizeRecipients = raw => {
    const list = Array.isArray(raw) ? raw : raw?.Data || raw?.data || []
    if (!Array.isArray(list)) return []
    const byEmail = new Map()
    list.forEach(item => {
        const email = String(item?.EmailAddress || item?.emailAddress || '').trim()
        if (!email) return
        const key = email.toLowerCase()
        const name = readName(item)
        const source = item?.Source || item?.source || 'Recent'
        const existing = byEmail.get(key)
        if (!existing) {
            byEmail.set(key, {
                email,
                name,
                source,
                companyId: Number(item?.CompanyId ?? item?.companyId) || 0,
            })
            return
        }
        if (!existing.name && name) existing.name = name
        if (isPartner(existing.source) && !isPartner(source)) existing.source = source
    })
    return [...byEmail.values()]
}

export const filterEmailSuggestions = (recipients, query, chips) => {
    const q = String(query || '').trim().toLowerCase()
    if (!q) return []
    const chosen = new Set(
        (chips || []).map(chip => String(chip.email || '').toLowerCase()),
    )
    const matched = (recipients || []).filter(item => {
        if (!item?.email || chosen.has(item.email.toLowerCase())) return false
        const name = String(item.name || '').toLowerCase()
        return item.email.toLowerCase().includes(q) || name.includes(q)
    })
    const recent = matched.filter(item => !isPartner(item.source))
    const partners = matched
        .filter(item => isPartner(item.source))
        .sort((a, b) =>
            String(a.name || a.email).localeCompare(
                String(b.name || b.email),
                undefined,
                { sensitivity: 'base' },
            ),
        )
    return [...recent, ...partners].slice(0, SUGGESTION_LIMIT)
}

export const sendErrorMessage = err => {
    const body = err?.error
    const text =
        typeof body === 'string'
            ? body
            : body?.message ||
              body?.Message ||
              body?.error ||
              body?.Error ||
              ''
    const message = String(text || '').trim()
    if (err?.status === 404) return 'This report belongs to another company.'
    if (/unable to send email/i.test(message)) {
        return "Couldn't send - try again in a minute."
    }
    if (message && message.length < 180) return message
    return 'Failed to send email'
}
